import { UNDISCLOSED_EVENT_VALUE } from '../../support/utils/eo_constants';

export const numberFormatter = (value) => {
  if (value === UNDISCLOSED_EVENT_VALUE) {
    return UNDISCLOSED_EVENT_VALUE;
  }

  return Math.round(Number(value));
};
